// @ts-ignore
import * as Vue from 'vue';
var allVue = Vue;
var gh = allVue.h;
var isV3 = allVue.version && allVue.version[0] === '3';
import { getTemplate } from '@progress/kendo-vue-common';
import { Button } from '@progress/kendo-vue-buttons';
/**
 * @hidden
 */

var DialogTitleBarVue2 = {
  props: {
    id: String,
    closeIcon: {
      type: Boolean,
      default: true
    },
    title: String,
    titleRender: [String, Function, Object]
  },
  // @ts-ignore
  setup: !isV3 ? undefined : function () {
    var v3 = !!isV3;
    return {
      v3: v3
    };
  },
  methods: {
    onCloseButtonClick: function onCloseButtonClick(e) {
      this.$emit('closebuttonclick', e);
    }
  },
  // @ts-ignore
  render: function render(createElement) {
    var h = gh || createElement;
    var _a = this.$props,
        id = _a.id,
        closeIcon = _a.closeIcon,
        titleRender = _a.titleRender,
        title = _a.title;
    var titleElement;
    titleElement = getTemplate.call(this, {
      h: h,
      template: titleRender,
      defaultRendering: title
    });
    return h("div", {
      "class": "k-window-titlebar k-dialog-titlebar k-header",
      id: id,
      attrs: this.v3 ? undefined : {
        id: id
      }
    }, [h("div", {
      "class": "k-window-title k-dialog-title"
    }, [titleElement]), h("div", {
      "class": "k-window-actions k-dialog-actions"
    }, [closeIcon && // @ts-ignore
    h(Button, {
      type: "button",
      attrs: this.v3 ? undefined : {
        type: "button",
        fillMode: 'flat',
        "aria-label": "Close",
        icon: 'x'
      },
      fillMode: 'flat',
      "aria-label": "Close",
      icon: 'x',
      onClick: this.onCloseButtonClick,
      on: this.v3 ? undefined : {
        "click": this.onCloseButtonClick
      }
    })])]);
  }
};
/**
 * @hidden
 */

var DialogTitleBar = DialogTitleBarVue2;
export { DialogTitleBar, DialogTitleBarVue2 };